import {faEdit} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useMemo} from 'react';

import {SourcesAccountType} from '../../../../../../../service/source-settings/accounts/accounts-type';
import {CatalogByGroupType} from '../../../../../../../service/source-settings/catalogs/catalogs-type';
import {StoreAccountListItemType} from '../../../../../../../service/source-settings/store-accounts/store-accounts-hook';
import {ActionsTableCell} from '../../actions-table-cell/actions-table-cell';

import {SourceAccountsTableType, StoreAccountsTableType} from './accounts-table-type';
import {EditAccount} from './edit-account/edit-account';
import {RemoveAccount} from './remove-account/remove-account';
import * as editLinkStyles from './edit-account/edit-account.scss';

type ArgsType = {
    accounts: Array<SourcesAccountType>;
    catalog: CatalogByGroupType;
    catalogGroupId: number;
    onEditStoreAccount?: (storeAccountId: number) => void;
    onSuccess: () => void;
    storeAccounts: Array<StoreAccountListItemType>;
};

type UseAccountsTableDataSourceReturnType = {
    sourceAccountsDataSource: Array<SourceAccountsTableType>;
    storeAccountsDataSource: Array<StoreAccountsTableType>;
};

export function useAccountsTableDataSource(args: ArgsType): UseAccountsTableDataSourceReturnType {
    const {accounts, catalog, catalogGroupId, onEditStoreAccount, onSuccess, storeAccounts} = args;

    const sourceAccountsDataSource = useMemo<Array<SourceAccountsTableType>>(
        () =>
            accounts.map((account) => ({
                ...account,
                key: account.id,
                actions: (
                    <ActionsTableCell>
                        {(account.editAbility || catalog.isKeyId) && (
                            <EditAccount
                                account={account}
                                catalog={catalog}
                                catalogGroupId={catalogGroupId}
                                onSuccess={onSuccess}
                            />
                        )}
                        <RemoveAccount account={account} onSuccess={onSuccess} />
                    </ActionsTableCell>
                ),
            })),
        [accounts, catalog, catalogGroupId, onSuccess]
    );

    const storeAccountsDataSource = useMemo<Array<StoreAccountsTableType>>(
        () =>
            storeAccounts.map((account) => ({
                ...account,
                key: account.id,
                actions: (
                    <ActionsTableCell>
                        <button
                            className={editLinkStyles.EditLinkButton}
                            onClick={() => onEditStoreAccount?.(account.id)}
                            type="button"
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <RemoveAccount account={account} isStoreAccount onSuccess={onSuccess} />
                    </ActionsTableCell>
                ),
            })),
        [onEditStoreAccount, onSuccess, storeAccounts]
    );

    return {sourceAccountsDataSource, storeAccountsDataSource};
}
